import { render, staticRenderFns } from "./poll-form.vue?vue&type=template&id=2d6bfedd&"
import script from "./poll-form.vue?vue&type=script&lang=js&"
export * from "./poll-form.vue?vue&type=script&lang=js&"
import style0 from "./poll-form.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "poll-form.vue"
export default component.exports